import { Module } from 'vuex';
import { IBriefingPage, IReportPage, IResourceModel, IScrapAgent, IScrollPage } from '@/shared/model/briefing-widget.model';
import BriefingService from '@/service/briefing.service';
import { sortBriefingPages, sortPinnedBriefing, sortScrapPin } from '@/util/ds-util';

export const briefingStore: Module<any, any> = {
  namespaced: true,
  state: {
    isSearchingBriefingAgent: false,
    isSearchingScrapAgent: false,
    totalResources: 0,
    selectedResource: {} as IResourceModel,
    selectedBriefingPage: {} as IBriefingPage,
    selectedReportPage: {} as IReportPage,
    selectedSocialPage: {} as IBriefingPage,
    selectedScrapAgent: {} as IScrapAgent,
    briefingPages: [] as IBriefingPage[],
    scrapAgents: [] as IScrapAgent[],
    defaultScrapAgents: {} as IScrapAgent,
    dailyBriefingAgent: {} as IScrapAgent,
    weeklyBriefingAgent: {} as IScrapAgent,
    scrapAgentsPinned: [] as IScrapAgent[],
    briefingAgentsPinned: [] as IBriefingPage[],
    totalBriefingPages: 0,
    totalScrapAgents: 0,
    totalBriefingPagesPinned: 0,
    totalScrapAgentPinned: 0,
    totalDefaultScrap: 0,
    isPinned: false,
    isPinnedScrap: false,
    totalSubscribeBriefing: 0,
    totalSubscribeCompany: 0,
    checkCallApiMyBP: true,
    checkCallApiMySA: true,
    loadingCallApiMySA: true,
    checkCallApiSubBP: true,
    checkCallApiCompanyBP: true,
    createBriefing: false,
    checkScopeBriefingPage: '',
    briefingNotFound: false,
    isPinInBriefingList: {} as { bpId: string; isPin: boolean },
    isPinInScrapList: {} as { bpId: string; isPin: boolean },
    scrollMyBriefingPage: { currentPage: 0, loadMore: true } as IScrollPage,
    scrollMyScrapAgent: { currentPage: 0, loadMore: true } as IScrollPage,
    scrollSubscribeBriefingPage: { currentPage: 0, loadMore: true } as IScrollPage,
    scrollSubscribeCompanyPage: { currentPage: 0, loadMore: true } as IScrollPage,
    scrollScrapAgentList: { currentPage: 0, loadMore: true } as IScrollPage,
    reportPages: [] as IReportPage[],
    recommendationPages: [] as IBriefingPage[],
    socialPages: [] as IBriefingPage[],
    companyPages: [] as IBriefingPage[],
    featuredPages: [] as IBriefingPage[],
    featuredCompanies: [] as IResourceModel[],
    referenceDocuments: new Array<any>(),
    addingReferenceDocuments: new Array<any>(),
    addingResources: [] as IResourceModel[],
    removingBriefingIds: [] as string[],
    isUpdateBriefing: false,
    isSubscribedBriefing: true,
    selectedUpdatingBriefingPage: {} as IBriefingPage,
    isShowDeleteBriefingSuccessMessage: false,
    isShowDeleteReportSuccessMessage: false,
    deleteBriefingPageInList: {} as {
      isDelete: false;
      oldLength: 0;
    },
    isHideSelectedResourceItem: false,
    isDoneHideSelectedResourceItem: false,
    selectedHideResource: {} as IResourceModel,
    companyBpDetail: {} as IBriefingPage, // Updated to companyBpDetail
    isCloseCompanyBpDetail: false,
    companyWidgetDetail: {} as {
      name: '';
      widgetData: any;
    },
    isSelectReportNoBriefingTab: false,
    isCreateNewBriefingFromChat: false,
    referenceDocumentsForReport: new Array<any>(),
    storeReferenceDocumentsForReport: new Array<any>(),
    isAllowGoOverAgain: false,
    watchSetTempReferenceDocuments: false,
    selectedReferenceTab: '',
    isShowInsightList: false,
    selectedReferenceIds: [] as string[],
    storeReferencesForEditByPage: new Array<any>(),
    isInReportInsightList: false,
    referenceDocumentsForNewBriefing: new Array<any>(),
    isForNewBriefing: false,
    reloadAfterEditedReport: false,
    newestRecap: {},
    updateResources: {},
    isOpenFromMyAskGoover: false,
    isLoadingBriefingWelcome: false,
  },
  getters: {
    getIsSearchingBriefingAgent: state => state.isSearchingBriefingAgent,
    getIsSearchingScrapAgent: state => state.isSearchingScrapAgent,
    getTotalResources: state => state.totalResources,
    getSelectedResource: state => state.selectedResource,
    getUpdateResources: state => state.updateResources,
    getSelectedBriefingPage: state => state.selectedBriefingPage,
    getSelectedReportPage: state => state.selectedReportPage,
    getSelectedSocialPage: state => state.selectedSocialPage,
    getSelectedScrapAgent: state => state.selectedScrapAgent,
    getCheckCallApiMyBP: state => state.checkCallApiMyBP,
    getCheckCallApiMySA: state => state.checkCallApiMySA,
    getLoadingCallApiMySA: state => state.loadingCallApiMySA,
    getCheckCallApiSubBP: state => state.checkCallApiSubBP,
    getCheckCallApiCompanyBP: state => state.checkCallApiCompanyBP,
    getCreateBriefing: state => state.createBriefing,
    getCheckScopeBriefingPage: state => state.checkScopeBriefingPage,
    getBriefingPages: state => state.briefingPages,
    getScrapAgents: state => state.scrapAgents,
    getDefaultScrapAgents: state => state.defaultScrapAgents,
    getDailyBriefingAgent: state => state.dailyBriefingAgent,
    getWeeklyBriefingAgent: state => state.weeklyBriefingAgent,
    getScrapAgentsPinned: state => state.scrapAgentsPinned,
    getBriefingAgentsPinned: state => state.briefingAgentsPinned,
    getDeleteBriefingPageInList: state => state.deleteBriefingPageInList,
    getTotalBriefingPages: state => state.totalBriefingPages,
    getTotalScrapAgents: state => state.totalScrapAgents,
    getIsPinned: state => state.isPinned,
    getIsPinnedScrap: state => state.isPinnedScrap,
    getTotalBriefingPagesPinned: state => state.totalBriefingPagesPinned,
    getTotalScrapAgentPinned: state => state.totalScrapAgentPinned,
    getTotalDefaultScrap: state => state.totalDefaultScrap,
    getTotalSubscribeBriefing: state => state.totalSubscribeBriefing,
    getTotalSubscribeCompany: state => state.totalSubscribeCompany,
    getScrollSubscribeBriefingPage: state => state.scrollSubscribeBriefingPage,
    getScrollSubscribeCompanyPage: state => state.scrollSubscribeCompanyPage,
    getScrollScrapAgentList: state => state.scrollScrapAgentList,
    getScrollMyBriefingPage: state => state.scrollMyBriefingPage,
    getScrollMyScrapAgent: state => state.scrollMyScrapAgent,
    getReportPages: state => state.reportPages,
    getIsPinInBriefingList: state => state.isPinInBriefingList,
    getIsPinInScrapList: state => state.isPinInScrapList,
    getRecommendationPages: state => state.recommendationPages,
    getSocialPages: state => state.socialPages,
    getCompanyPages: state => state.companyPages,
    getBriefingNotFound: state => state.briefingNotFound,
    getFeaturedPages: state => state.featuredPages,
    getFeaturedCompanies: state => state.featuredCompanies,
    getReferenceDocuments: state => state.referenceDocuments,
    getAddingReferenceDocuments: state => state.addingReferenceDocuments,
    getAddingResources: state => state.addingResources,
    getRemovingBriefingIds: state => state.removingBriefingIds,
    isUpdateBriefing: state => state.isUpdateBriefing,
    isSubscribedBriefing: state => state.isSubscribedBriefing,
    getSelectedUpdatingBriefingPage: state => state.selectedUpdatingBriefingPage,
    getIsShowDeleteBriefingSuccessMessage: state => state.isShowDeleteBriefingSuccessMessage,
    getIsShowDeleteReportSuccessMessage: state => state.isShowDeleteReportSuccessMessage,
    getIsHideSelectedResourceItem: state => state.isHideSelectedResourceItem,
    getIsDoneHideSelectedResourceItem: state => state.isDoneHideSelectedResourceItem,
    getSelectedHideResource: state => state.selectedHideResource,
    getCompanyBpDetail: state => state.companyBpDetail,
    getIsCloseCompanyBpDetail: state => state.isCloseCompanyBpDetail,
    getCompanyWidgetDetail: state => state.companyWidgetDetail,
    getIsSelectReportNoBriefingTab: state => state.isSelectReportNoBriefingTab,
    getReferenceDocumentsForReport: state => state.referenceDocumentsForReport,
    getStoreReferenceDocumentsForReport: state => state.storeReferenceDocumentsForReport,
    getIsAllowGoOverAgain: state => state.isAllowGoOverAgain,
    getWatchSetTempReferenceDocuments: state => state.watchSetTempReferenceDocuments,
    getSelectedReferenceTab: state => state.selectedReferenceTab,
    getIsShowInsightList: state => state.isShowInsightList,
    getSelectedReferenceIds: state => state.selectedReferenceIds,
    getStoreReferencesForEditByPage: state => state.storeReferencesForEditByPage,
    getIsInReportInsightList: state => state.isInReportInsightList,
    getReferenceDocumentsForNewBriefing: state => state.referenceDocumentsForNewBriefing,
    getIsForNewBriefing: state => state.isForNewBriefing,
    getIsCreateNewBriefingFromChat: state => state.isCreateNewBriefingFromChat,
    getReloadAfterEditedReport: state => state.reloadAfterEditedReport,
    getBriefingPageModifyDate: state => (bpId: string) => {
      const briefingPage = state.briefingPages.find(page => page.bpId === bpId);
      return briefingPage ? briefingPage.modifyDate : null;
    },
    getNewestRecap: state => state.newestRecap,
    getIsOpenFromMyAskGoover: state => state.isOpenFromMyAskGoover,
    getIsLoadingBriefingWelcome: state => state.isLoadingBriefingWelcome,
  },
  mutations: {
    setIsSearchingBriefingAgent(state, payload: boolean) {
      state.isSearchingBriefingAgent = payload;
    },
    setIsSearchingScrapAgent(state, payload: boolean) {
      state.isSearchingScrapAgent = payload;
    },
    setTotalResources(state, totalResources) {
      state.totalResources = totalResources;
    },
    updateModifyDate(state, { bpId, modifyDate }) {
      const briefingPage = state.briefingPages.find(page => page.bpId === bpId);
      if (briefingPage) {
        console.log(`briefing page modifyDate from ${briefingPage.modifyDate} updated to ${modifyDate}`);
        briefingPage.modifyDate = modifyDate;
      }
    },
    setSelectedResource(state, resource) {
      const tempBpId =
        resource?.bpId ||
        resource.parentDocDetail?.briefing_page_id?.[0] ||
        resource.originParentDocDetail?.briefing_page_id?.[0] ||
        undefined;

      const tempUserKey =
        resource?.owner_user_key ||
        resource.parentDocDetail?.owner_user_key ||
        resource.originParentDocDetail?.owner_user_key ||
        resource?.userKey ||
        resource.parentDocDetail?.userKey ||
        resource.originParentDocDetail?.userKey ||
        undefined;

      state.selectedResource =
        tempBpId !== undefined || tempUserKey !== undefined
          ? {
              ...resource,
              bpId: tempBpId,
              owner_user_key: tempUserKey,
            }
          : resource;
    },
    setSelectedBriefingPage(state, briefingPage) {
      state.selectedBriefingPage = briefingPage;
    },
    setUpdateResources(state, selectedResource) {
      state.updateResources = selectedResource;
    },
    setIsPinInBriefingList(state, isPinInBriefingList: { bpId: string; isPin: boolean }) {
      state.isPinInBriefingList = isPinInBriefingList;
    },
    setIsPinInScrapList(state, isPinInScrapList: { bpId: string; isPin: boolean }) {
      state.isPinInScrapList = isPinInScrapList;
    },
    setBriefingNotFound(state, briefingNotFound) {
      state.briefingNotFound = briefingNotFound;
    },
    setCheckCallApiMyBP(state, checkCallApiMyBP) {
      state.checkCallApiMyBP = checkCallApiMyBP;
    },
    setCheckCallApiMySA(state, checkCallApiMySA) {
      state.checkCallApiMySA = checkCallApiMySA;
    },
    setLoadingCallApiMySA(state, loadingCallApiMySA) {
      state.loadingCallApiMySA = loadingCallApiMySA;
    },
    setCheckCallApiSubBP(state, checkCallApiSubBP) {
      state.checkCallApiSubBP = checkCallApiSubBP;
    },
    setCheckCallApiCompanyBP(state, checkCallApiCompanyBP) {
      state.checkCallApiCompanyBP = checkCallApiCompanyBP;
    },
    setDeleteBriefingPageInList(state, deleteBriefingPageInList: { isDelete: boolean; oldLength: number }) {
      state.deleteBriefingPageInList = deleteBriefingPageInList;
    },
    setCreateBriefing(state, createBriefing) {
      state.createBriefing = createBriefing;
    },
    setCheckScopeBriefingPage(state, checkScopeBriefingPage) {
      state.checkScopeBriefingPage = checkScopeBriefingPage;
    },
    setSelectedSocialPage(state, socialPages) {
      state.selectedSocialPage = socialPages;
    },
    setSelectedScrapAgent(state, scrapAgent) {
      state.selectedScrapAgent = scrapAgent;
    },
    setScrollMyBriefingPage(state, scrollMyBriefingPage) {
      state.scrollMyBriefingPage = scrollMyBriefingPage;
    },
    setScrollMyScrapAgent(state, scrollMyScrapAgent) {
      state.scrollMyScrapAgent = scrollMyScrapAgent;
    },
    setScrollSubscribeBriefingPage(state, scrollSubscribeBriefingPage) {
      state.scrollSubscribeBriefingPage = scrollSubscribeBriefingPage;
    },
    setScrollSubscribeCompanyPage(state, scrollSubscribeCompanyPage) {
      state.scrollSubscribeCompanyPage = scrollSubscribeCompanyPage;
    },
    setScrollScrapAgentList(state, scrollScrapAgentList) {
      state.scrollScrapAgentList = scrollScrapAgentList;
    },
    setBriefingPages(state, briefingPages) {
      // debugger;
      // if (briefingPages.length > 0) {
      //   const pinBps: IBriefingPage[] = briefingPages.filter(page => page.isPinned);
      //   if (pinBps.length > 3) {
      //     // select top 3 is pinned
      //     state.briefingPages = pinBps.map((item, index) => {
      //       if (index > 2) {
      //         return { ...item, isPinned: false };
      //       }
      //       return item;
      //     });
      //     return;
      //   }
      // }

      // test for all pin pls not remove
      state.briefingPages = briefingPages;
    },
    setScrapAgents(state, scrapAgents) {
      state.scrapAgents = scrapAgents;
    },
    setDefaultScrapAgents(state, defaultScrapAgents) {
      state.defaultScrapAgents = defaultScrapAgents;
    },
    setDailyBriefingAgent(state, dailyBriefingAgent) {
      state.dailyBriefingAgent = dailyBriefingAgent;
    },
    setWeeklyBriefingAgent(state, weeklyBriefingAgent) {
      state.weeklyBriefingAgent = weeklyBriefingAgent;
    },
    setScrapAgentsPinned(state, scrapAgentsPinned) {
      state.scrapAgentsPinned = scrapAgentsPinned;
    },
    setBriefingAgentsPinned(state, briefingAgentsPinned) {
      state.briefingAgentsPinned = briefingAgentsPinned;
    },
    setTotalBriefingPages(state, totalBriefingPages) {
      state.totalBriefingPages = totalBriefingPages;
    },
    setTotalScrapAgents(state, totalScrapAgents) {
      state.totalScrapAgents = totalScrapAgents;
    },
    setIsPinned(state, isPinned) {
      state.isPinned = isPinned;
    },
    setIsPinnedScrap(state, isPinnedScrap) {
      state.isPinnedScrap = isPinnedScrap;
    },
    setTotalBriefingPagesPinned(state, totalBriefingPagesPinned) {
      state.totalBriefingPagesPinned = totalBriefingPagesPinned;
    },
    setTotalScrapAgentPinned(state, totalScrapAgentPinned) {
      state.totalScrapAgentPinned = totalScrapAgentPinned;
    },
    setTotalDefaultScrap(state, totalDefaultScrap) {
      state.totalDefaultScrap = totalDefaultScrap;
    },
    setTotalSubscribeBriefing(state, totalSubscribeBriefing) {
      state.totalSubscribeBriefing = totalSubscribeBriefing;
    },
    setTotalSubscribeCompany(state, totalSubscribeCompany) {
      state.totalSubscribeCompany = totalSubscribeCompany;
    },
    setRecommendationPages(state, recommendationPages) {
      state.recommendationPages = recommendationPages;
    },
    setSocialPages(state, socialPages) {
      state.socialPages = socialPages;
    },
    setCompanyPages(state, companyPages) {
      state.companyPages = companyPages;
    },
    setFeaturedPages(state, featuredPages) {
      state.featuredPages = featuredPages;
    },
    setFeaturedCompanies(state, featuredCompanies) {
      state.featuredCompanies = featuredCompanies;
    },
    setReferenceDocuments(state, referenceDocuments) {
      if (!referenceDocuments || referenceDocuments.length == 0) {
        state.referenceDocuments = new Array<any>();
        return;
      }
      referenceDocuments.map(doc => (doc.parentDocId = doc?.parentDocId || doc?.doc_id || ''));
      state.referenceDocuments = referenceDocuments;
    },
    setAddingReferenceDocuments(state, addingReferenceDocuments) {
      state.addingReferenceDocuments = addingReferenceDocuments;
    },
    setAddingResources(state, addingResources) {
      state.addingResources = addingResources;
    },
    setRemovingBriefingIds(state, removingBriefingIds) {
      state.removingBriefingIds = removingBriefingIds;
    },
    updateTotalResources(state, counter) {
      state.totalResources += counter;
    },
    updateAddingResources(state, resource: IResourceModel) {
      if (!resource.isBookmarked) {
        const index = state.addingResources.findIndex(el => el._id === resource._id);
        if (index > -1) {
          state.addingResources.splice(index, 1);
        }
      } else {
        state.addingResources.push(resource);
      }
    },
    resetAddingReferenceDocuments(state) {
      state.addingReferenceDocuments = [];
    },
    addToReferentDocuments(state, docIds) {
      for (let i = 0; i < docIds.length; i++) {
        const exist = state.referenceDocuments.some(
          referenceDocument => referenceDocument.path === docIds[i].path || referenceDocument.parentDocId === docIds[i].parentDocId
        );
        if (!exist) {
          state.referenceDocuments.push(docIds[i]);
        }
      }
    },
    removeFromReferenDocuments(state, docIdsToRemove) {
      for (let i = 0; i < docIdsToRemove.length; i++) {
        const index = state.referenceDocuments.findIndex(document => document.parentDocId === docIdsToRemove[i]);
        if (index > -1) {
          state.referenceDocuments.splice(index, 1);
        }
      }
    },
    setIsUpdateBriefing(state, isUpdateBriefing) {
      state.isUpdateBriefing = isUpdateBriefing;
    },
    setIsSubscribedBriefing(state, isSubscribedBriefing) {
      state.isSubscribedBriefing = isSubscribedBriefing;
    },
    updateBriefingPages(state?, briefingPages?) {
      state.briefingPages = briefingPages;
    },
    updateScrapAgents(state?, scrapAgents?) {
      state.scrapAgents = scrapAgents;
    },
    updateScrapAgentsPinned(state?, scrapAgentsPinned?) {
      state.scrapAgentsPinned = scrapAgentsPinned;
    },
    updateBriefingAgentsPinned(state?, briefingAgentsPinned?) {
      state.briefingAgentsPinned = briefingAgentsPinned;
    },
    setSelectedUpdatingBriefingPage(state, selectedUpdatingBriefingPage) {
      state.selectedUpdatingBriefingPage = selectedUpdatingBriefingPage;
    },
    setIsShowDeleteBriefingSuccessMessage(state, isShowDeleteBriefingSuccessMessage) {
      state.isShowDeleteBriefingSuccessMessage = isShowDeleteBriefingSuccessMessage;
    },
    setIsHideSelectedResourceItem(state, isHideSelectedResourceItem) {
      state.isHideSelectedResourceItem = isHideSelectedResourceItem;
    },
    setIsDoneHideSelectedResourceItem(state, isDoneHideSelectedResourceItem) {
      state.isDoneHideSelectedResourceItem = isDoneHideSelectedResourceItem;
    },
    setSelectedHideResource(state, selectedHideResource) {
      state.selectedHideResource = selectedHideResource;
    },
    setCompanyBpDetail(state, companyBpDetail) {
      state.companyBpDetail = companyBpDetail;
    },
    setIsCloseCompanyBpDetail(state, isCloseCompanyBpDetail) {
      state.isCloseCompanyBpDetail = isCloseCompanyBpDetail;
    },
    setIsShowInsightList(state, isShowInsightList) {
      state.isShowInsightList = isShowInsightList;
    },
    setCompanyWidgetDetail(state, companyWidgetDetail: { name: string; widgetData: any }) {
      state.companyWidgetDetail = companyWidgetDetail;
    },
    setIsSelectReportNoBriefingTab(state, isSelectReportNoBriefingTab) {
      state.isSelectReportNoBriefingTab = isSelectReportNoBriefingTab;
    },
    setReferenceDocumentsForReport(state, referenceDocumentsForReport) {
      state.referenceDocumentsForReport = referenceDocumentsForReport;
    },
    setStoreReferenceDocumentsForReport(state, storeReferenceDocumentsForReport) {
      state.storeReferenceDocumentsForReport = storeReferenceDocumentsForReport;
    },
    setIsAllowGoOverAgain(state, isAllowGoOverAgain) {
      state.isAllowGoOverAgain = isAllowGoOverAgain;
    },
    setWatchSetTempReferenceDocuments(state, watchSetTempReferenceDocuments) {
      state.watchSetTempReferenceDocuments = watchSetTempReferenceDocuments;
    },
    setSelectedReferenceTab(state, selectedReferenceTab) {
      state.selectedReferenceTab = selectedReferenceTab;
    },
    setSelectedReferenceIds(state, selectedReferenceIds: string[]) {
      state.selectedReferenceIds = selectedReferenceIds;
    },
    setStoreReferencesForEditByPage(state, storeReferencesForEditByPage: any[]) {
      state.storeReferencesForEditByPage = storeReferencesForEditByPage;
    },
    setIsInReportInsightList(state, isInReportInsightList: boolean) {
      state.isInReportInsightList = isInReportInsightList;
    },
    setReferenceDocumentsForNewBriefing(state, referenceDocumentsForNewBriefing: any[]) {
      state.referenceDocumentsForNewBriefing = referenceDocumentsForNewBriefing;
    },
    setIsForNewBriefing(state, isForNewBriefing: boolean) {
      state.isForNewBriefing = isForNewBriefing;
    },
    setIsCreateNewBriefingFromChat(state, isCreateNewBriefingFromChat: boolean) {
      state.isCreateNewBriefingFromChat = isCreateNewBriefingFromChat;
    },
    setReloadAfterEditedReport(state, reloadAfterEditedReport: boolean) {
      state.reloadAfterEditedReport = reloadAfterEditedReport;
    },
    setNewestRecap(state, recap) {
      state.newestRecap = recap;
    },
    setIsOpenFromMyAskGoover(state, isOpenFromMyAskGoover: boolean) {
      state.isOpenFromMyAskGoover = isOpenFromMyAskGoover;
    },
    setIsLoadingBriefingWelcome(state, isLoadingBriefingWelcome: boolean) {
      state.isLoadingBriefingWelcome = isLoadingBriefingWelcome;
    },
  },
  actions: {
    removeFromReferenDocuments: async (context, payload: { docIdsToRemove: [] }) => {
      context.commit('removeFromReferenDocuments', payload.docIdsToRemove);
    },
    updatePinBriefing: async (context, { bpId, isPin }) => {
      try {
        const sourceCollection = isPin ? context.state.briefingPages : context.state.briefingAgentsPinned;
        const itemUpdateIndex = sourceCollection.findIndex(bp => bp.bpId === bpId);
        if (isPin && itemUpdateIndex < 0) return;
        let itemUpdate = {
          ...(context.state.briefingPages.find(bp => bp.bpId === bpId) || sourceCollection[itemUpdateIndex]),
          isPinned: isPin,
        };
        if (isPin) {
          itemUpdate = { ...itemUpdate, pinAt: new Date().getTime() };
        }
        const listFilter = context.state.briefingPages.filter(bp => bp.bpId !== bpId);
        const updatedBriefingPages: IBriefingPage[] = sortBriefingPages([itemUpdate, ...listFilter]);
        let updateBriefingPinned: IBriefingPage[];
        if (isPin) {
          const listPin = context.state.briefingAgentsPinned;
          updateBriefingPinned = sortPinnedBriefing([itemUpdate, ...listPin]);
        } else {
          updateBriefingPinned = sortPinnedBriefing(context.getters.getBriefingAgentsPinned.filter(item => item.bpId !== bpId));
        }
        context.commit('updateBriefingPages', updatedBriefingPages);
        context.commit('updateBriefingAgentsPinned', updateBriefingPinned);
        const newPinnedCount = isPin ? context.getters.getTotalBriefingPagesPinned + 1 : context.getters.getTotalBriefingPagesPinned - 1;
        context.commit('setTotalBriefingPagesPinned', newPinnedCount);
        const selected = context.state.selectedBriefingPage;
        if (selected.bpId === bpId) {
          context.commit('setSelectedBriefingPage', { ...selected, isPinned: isPin });
        }
        const userKey = JSON.parse(localStorage.getItem('localStorageUser'))?.id || null;
        const briefingService = new BriefingService();
        await briefingService.updatePinBriefing(bpId, isPin, userKey, 1);
      } catch (err) {
        console.error(err);
      }
    },
    updatePinScrap: async (context, { bpId, isPin }) => {
      context.commit('setIsPinnedScrap', true);
      const itemUpdateIndex = context.state.scrapAgents.findIndex(item => item.bpId === bpId);
      if (itemUpdateIndex < 0) return;
      const itemUpdate = { ...context.state.scrapAgents[itemUpdateIndex], isPinned: isPin };
      const listPin = context.state.scrapAgents.filter(item => item.isPinned);
      const listFilter = context.state.scrapAgents.filter(bp => bp.bpId !== bpId);
      let updatedScrapAgents = null;
      let updateScrapPinned = null;
      if (isPin) {
        // const pinnedItem = context.state.scrapAgents.filter(bp => bp.isPinned)
        updatedScrapAgents = sortScrapPin([itemUpdate, ...listFilter]);
        updateScrapPinned = sortScrapPin([itemUpdate, ...listPin]);
        context.commit('updateScrapAgents', updatedScrapAgents);
        context.commit('updateScrapAgentsPinned', updateScrapPinned);
        context.commit('setTotalScrapAgentPinned', context.getters.getTotalScrapAgentPinned + 1);
      } else {
        updatedScrapAgents = sortScrapPin([itemUpdate, ...listFilter]);
        updateScrapPinned = context.getters.getScrapAgentsPinned.filter(item => item.bpId !== bpId);
        updateScrapPinned = sortScrapPin(updateScrapPinned);
        context.commit('updateScrapAgents', updatedScrapAgents);
        context.commit('updateScrapAgentsPinned', updateScrapPinned);
        context.commit('setTotalScrapAgentPinned', context.getters.getTotalScrapAgentPinned - 1);
      }

      // updatedScrapAgents = isPin ? [itemUpdate, ...listFilter] : [...listFilter, itemUpdate];

      const briefingService = new BriefingService();
      const userKey = JSON.parse(localStorage.getItem('localStorageUser'))?.id || null;
      await briefingService
        .updatePinBriefing(bpId, isPin, userKey, 4)
        .then(response => {
          // if (response.data.status == 3) {
          //   if api call failed refresh data
          //   context.commit('appStore/setIsShowAlertPinBriefing', true, { root: true });\
          if (response.status === 200) {
            context.commit('setIsPinnedScrap', false);
          }
          const updateItem: Array<any> = response.data.body;
          const list = context.state.scrapAgents;
          const listFilter = list.map(item => {
            return {
              ...item,
              isPinned: updateItem.includes(item.bpId),
            };
          });
          // const newUpdatedScrapAgents = sortScrapPin(listFilter);
          // context.commit('updateScrapAgents', newUpdatedScrapAgents);
          // }
        })
        .catch(err => {
          context.commit('setIsPinnedScrap', false);
        });
    },
  },
};
